import { faBell } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import NotificationsFeed from "../../components/CommandCenter/notificationsFeed";
import ComponentHeader from "../../components/UI/ComponentHeader";
import Helper from "../../Helper";
import { CommandMessage } from "../CommandTypes";
import { JobsiteCommandContext } from "../JobsiteCommandProvider";

interface DashboardJobsiteAlertsProps {
    messages: CommandMessage[];
    timezone: string;
}

const DashboardJobsiteAlerts: React.FC<DashboardJobsiteAlertsProps> = ({ messages, timezone }) => {
    const commandContext = React.useContext(JobsiteCommandContext);
    const isPortrait = commandContext?.isPortrait ?? false;

    return (
        <div
            className={Helper.classNames(
                "flex flex-col gap-2 h-full w-full min-h-0 overflow-hidden",
                !isPortrait && "grow"
            )}
        >
            <ComponentHeader label="Jobsite Alerts" icon={faBell} color="text-plot-orange" />
            <NotificationsFeed messages={messages} timezone={timezone} />
        </div>
    );
};

export default DashboardJobsiteAlerts;
